import { useState } from 'react';
import './App.css';
import { toast,ToastContainer } from 'react-toastify';
import {numbers,uppercaseLetters,lowercaseLetters,specialCharacters} from "./Characters";
import 'react-toastify/dist/ReactToastify.css'
import {COPY_SUCCESS} from "./message";

function App() {
  const [password, setPassword]=useState("");
  const [passwordlength,setpasswordlength]=useState(20);
  const [includeuppercase,setuppercase]=useState(false);
  const [includelowercase,setlowercase]=useState(false);
  const [includenumebrs,setumbers]=useState(false);
  const [includesymbols,setsymbols]=useState(false);
  const handleGeneratePassword=(e)=>{
    if(!includeuppercase && !includelowercase && !includenumebrs && !includesymbols){
      notify("You must select atleast one option",true)
    }
    let characterlist="";
    if(includelowercase){
      characterlist=characterlist+lowercaseLetters;
    }
    if(includeuppercase){
      characterlist=characterlist+uppercaseLetters;
    }
    if(includenumebrs){
      characterlist=characterlist+numbers;

    }
    if(includesymbols){
      characterlist=characterlist+specialCharacters;

    }
    setPassword(createPassword(characterlist));
  }
  const createPassword=(characterlist)=>{
    let password=""
    const characterlistLength=characterlist.length
    for (let i=0;i <passwordlength;i++){
      const characterIndex=Math.round(Math.random()*characterlistLength)
  password=password+characterlist.charAt(characterIndex)
    }
    return password;
}
const copytoClipboard=()=>{
  const newTextArea=document.createElement('textarea');
  newTextArea.innerText=password;
  document.body.appendChild(newTextArea);
  newTextArea.select()
  document.execCommand("copy")
  newTextArea.remove();
}
const notify=(message, haserror=false)=>{
  if(haserror){
toast.error(message,{
  position:"top-center",
  autoClose:5000,
  hideProgressBar:false,
  closeOnClick:true,
  pauseOnHover:true,
  draggable:true,
  progress: undefined,
})
  }
  else{
    toast(message,{
      position:"top-center",
      autoClose:5000,
      hideProgressBar:false,
      closeOnClick:true,
      pauseOnHover:true,
      draggable:true,
      progress:undefined,
    });
  }
  
}

const handleCopypassword=(e)=>{
  if(password===''){
    notify("Nothing to Copy",true)
  }
  else{
    copytoClipboard()
    notify(COPY_SUCCESS)
  }
}
  return (
    <div className="App">
     <div className='container'>
       <div className='generator'>
         <h2 className='generator_header'>
           Password Generator
         </h2>
         <div className='generator_password'>
           <h3>{password}</h3>
           <button className='copy_btn' onClick={handleCopypassword}>
             <i className='far fa-clipboard'></i>
           </button>
         </div>
         <div className='form_group'>
           <label htmlFor='password-strength'>Password Length</label>
           <input
           defaultValue={passwordlength}
           onChange={(e)=>setpasswordlength(e.target.value)}
           type="number" id="password-strength" name="password-strength" max="20" min="10"/>
          </div>
           <div className='form_group'>
             
           <label htmlFor='uppercase-letters'>Include Uppercase Letters</label>
           <input
           checked={includeuppercase}
           onChange={(e)=>setuppercase(e.target.checked)} type="checkbox" id="uppercase-letters" name="uppercase-letters"/>

         </div>
         <div className='form_group'>
             
             <label htmlFor='lowercase-letters'>Include Lowercase Letters</label>
             <input
             checked={includelowercase}
            onChange={(e)=>setlowercase(e.target.checked)}
            type="checkbox" id="lowercase-letters" name="lowercase-letters"/>
  
           </div>
           <div className='form_group'>
             
             <label htmlFor='numbers'>Include Numbers</label>
             <input
             checked={includenumebrs}
             onChange={(e)=>setumbers(e.target.checked)} type="checkbox" id="include-numbers" name="include-numbers"/>
  
           </div>
           <div className='form_group'>
             
             <label htmlFor='symbols'>Include Symbols</label>
             <input 
             checked={includesymbols}
             onChange={(e)=>setsymbols(e.target.checked)}
             type="checkbox" id="include-symbols" name="include-symbols"/>
  
           </div>
           <button onClick={handleGeneratePassword} className='generator_btn'>Generate Password</button>
           <ToastContainer
           position='top-center'
           autoClose={5000}
           hideProgressBar={false}
           newestOnTop={false}
           closeOnClick
           rtl={false}
           pauseOnFocusLoss
           draggable
           pauseOnHover/>

       
       
       </div>
     </div>

    </div>
  );
}

export default App;
